import { Vue, Component, Prop } from 'vue-property-decorator'
import { DocumentDetail, TableHeader } from '@/types'

@Component
export default class DocumentDetailComponent extends Vue {
  @Prop()
  items!: DocumentDetail[]

  @Prop()
  document!:Document

  headers: TableHeader[] = [
    {
      text: 'Codigo',
      value: 'codarti'
    },
    {
      text: 'Descripción',
      value: 'descri'
    },
    {
      text: 'U. Medida',
      value: 'cod_unid1'
    },
    {
      text: 'Cantidad',
      value: 'cant'
    },
    {
      text: 'Precio',
      value: 'prec'
    },
    {
      text: 'Importe',
      value: 'importe'
    }
  ]
}
